import React from 'react';
import { FormattedMessage } from 'react-intl';

import H2 from '../../../../components/atoms/H2';
import Paragraph from '../../../../components/atoms/Paragraph';

import { ContentWrapper } from './styled';

const NoAccess = () => {
  return (
    <>
      <ContentWrapper>
        <H2>
          <FormattedMessage id="lounge.hero.title" />
        </H2>
        <Paragraph>
          <FormattedMessage id="lounge.hero.subtitle" />
        </Paragraph>
      </ContentWrapper>
    </>
  );
};

export default NoAccess;
